// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"79":"707e911f","113":"f2217675","138":"07fdf7d9","394":"ca9d14b1","416":"af506aab","517":"599a5c45","573":"ab590763","761":"ec643b4e","898":"4ea12c91"}[chunkId] + ".js";
};